import {Controller} from "@hotwired/stimulus"

// Hides the story sidebar down to a slim strip. Like the dragged width, the
// choice is remembered per story in this browser only, so another person
// still gets the sidebar. The partial's inline script applies a saved choice
// before the first paint; connect() repeats it for renders that skipped it.
// Shift+B is wired in nav_shortcuts with the other story shortcuts.
export default class extends Controller {
  static targets = ["panel", "strip", "hideButton", "showButton"]
  static values = {key: String}

  connect() {
    this.element.toggleAttribute("data-collapsed", this.readHidden())
  }

  hide() {
    // The panel leaves the page, so focus inside it would drop to <body>.
    const hadFocus = this.panelTarget.contains(document.activeElement)
    this.apply(true)
    if (hadFocus) this.showButtonTarget.focus()
  }

  show() {
    const hadFocus = this.stripTarget.contains(document.activeElement)
    this.apply(false)
    if (hadFocus) this.hideButtonTarget.focus()
  }

  apply(hidden) {
    this.element.toggleAttribute("data-collapsed", hidden)
    try {
      if (hidden) localStorage.setItem(this.keyValue, "1")
      else localStorage.removeItem(this.keyValue)
    } catch {
      // Private browsing can reject storage. The sidebar still toggles for this visit.
    }
  }

  readHidden() {
    try {
      return localStorage.getItem(this.keyValue) === "1"
    } catch {
      return false
    }
  }
}
